<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li>首页</li>
                <li>短信</li>
                <li>短地址群发</li>
            </ul>
            <span class="ea2020">{{smsCount}}</span>
        </div>
        <div class="formbody">
            <div id="usual1" class="usual"> 
  	            <div class="formbody">
                    <el-input type="text" v-model="txtpath" v-show="false" />
                    <el-input type="text" v-model="format" v-show="false" />
                    <div class="formtitle">
                        <span>短地址群发&nbsp;&nbsp;</span>
                        <div class="help-tip">
                            <p>短链接群发功能介绍：<br/>
                        1.当你的短信发出，短信点击量和点击率，第一时间知道的方法；<br/>
                        2.短信营销是一个持续不断的过程，营销短信内容用户是否感兴趣？用户是否点击短信内容中的链接；<br/>
                        3.有多少用户点击了内容中的链接？二办特推出短地址群发，营销效果一目了然；<br/>
                        4.将长串活动链接生成为二办短地址，有利于控制短信长度。短信送达用户后，可在二办平台查看短信内的链接被点击情况，从而优化短信发送时间、内容和人群等，转化效果清晰可见。还可每个手机号码生成不同短地址，用户可通过二办平台查看具体某个手机点击情况，以便二次营销。<br/></p>
                        </div>
                    </div>
                    <ul class="forminfo" v-show="isShowSmsSend">    
                        <li v-show="isBindMobile">
                            <label>提醒<b>*</b></label>
                             
                            <div class="buttonupload  click left" @click="gotoBindMobile()" style="margin-left:20px;"><font color="red"><strong>您还未绑定手机号码，点击去绑定手机号码！</strong></font></div>   
                        </li> 
                        <li>
                            <label>1原始链接<b>*</b></label>
                            <cite class="left">
                                <input type="text" class="dfinput maringht10" placeholder="原始链接，最大长度100" v-model="srcUrl" />
                            </cite> 
                        </li> 
                        <li>
                            <label>2地址有效期<b>*</b></label>
                            <cite class="left">
                                <input name="urlDate" type="radio" v-model="urlDate" value="5" />5天
                                &nbsp;&nbsp;<input name="urlDate" type="radio" v-model="urlDate" value="15" />15天
                                &nbsp;&nbsp;<input name="urlDate" type="radio" v-model="urlDate" value="30" />30天
                                &nbsp;&nbsp;<input name="urlDate" type="radio" v-model="urlDate" value="60" />60天
                            </cite> 
                        </li> 
                        <li><label>3选通道<b>*</b></label>
                            <div class="vocation" >
                                <el-select v-model="channelcode" style="width:500px;" placeholder="点击下拉 (温馨提醒：短信末尾均需添加签名;夜间请勿发送太晚，引起投诉）">
                                    
                                    <template v-if="isShowFee == '0'">
                                        <el-option v-if="item.supportReply == 1"
                                            v-for="item in smschannelList"
                                            :key="item.channelCode"
                                            :label="item.channelDes+ ',可回复'"
                                            :value="item.channelCode">
                                        </el-option>
                                        <el-option v-if="item.supportReply == 0"
                                            v-for="item in smschannelList"
                                            :key="item.channelCode"
                                            :label="item.channelDes+ ',不可回复'"
                                            :value="item.channelCode">
                                        </el-option>
                                    </template>
                                    <template v-if="isShowFee == '1'">
                                        <el-option v-if="item.supportReply == 1"
                                            v-for="item in smschannelList"
                                            :key="item.channelCode"
                                            :label="item.channelDes+(item.channelFee+'元/条') + ',可回复'"
                                            :value="item.channelCode">
                                        </el-option>
                                        <el-option v-if="item.supportReply == 0"
                                            v-for="item in smschannelList"
                                            :key="item.channelCode"
                                            :label="item.channelDes+(item.channelFee+'元/条') + ',不可回复'"
                                            :value="item.channelCode">
                                        </el-option>
                                    </template>
                                </el-select>
                            </div>
                        </li>    
                        <li>
                            <label>4选签名<b>*</b></label>
                            <cite class="left">
                                <template v-for="(item,index) in signList">
                                    <input name="" @change="changeSign(item.sign)" v-model="sign" type="radio" :value="item.sign" />{{item.sign}}&nbsp;&nbsp;&nbsp;&nbsp;                                 
                                </template>
                            </cite> 
                            <div class="buttonupload  click left" @click="gotoSign()" style="margin-left:20px;">添加签名</div>   
                        </li>    
                        <li>
                            <label>5接收号<b>*</b></label>
                            <textarea name="" v-model="mobile" cols="" rows="" class="textinput left maringht10" style="overflow-y:auto;">

                            </textarea>
                        </li>    
                        <li>
                            <label> &nbsp; </label>
                            <div class="buttonupload  click maringht10" @click="addTxl()"> 通讯录添加 </div> 
                            <div style="float: left; padding-right: 10px;"> 
                                <el-upload
                                    class="upload-demo"
                                    :on-success="uploadSuccess"
                                    :action=smsTxtUploadUrl
                                    accept=".txt" 
                                    :show-file-list="false"
                                    :headers="uploadHeaders"
                                    :on-change="handleChange">
                                    <el-button size="small" type="primary">点击文件导入（txt记事本格式）</el-button>
                                </el-upload> 
                            </div>
                            <div class="buttonupload  click maringht10" @click="addSmsContTxt()"> 导入群发记录 </div>
                        </li>    
                        <li>
                            <label>4内容<b>*</b></label>
                            <textarea id="content" name="content" @input="tjcontentlen()" v-model="content" cols="" rows="" class="textinput left maringht10" style="overflow-y:auto;">
                            </textarea>
                            <div class="buttonupload  click" @click="addFromSmsContent()">短信库添加模板</div>
                            <el-button type="primary" @click="addShortUrl()">光标处插入短地址</el-button>
                        </li>                        
                        <li>
                            <label> &nbsp; </label><div class="toolbars lh33">每条短信70字符,最长支持300字符。</div>
                        </li>
                        <li>
                            <label> &nbsp; </label><div class="toolbars lh33">短信内容含签名共<b><input name="" v-model="tjs" type="text" class="dfinput maringht10" readonly="readonly" style="width:40px; color:red;" /></b>字符;</div>
                        </li>
    
                        <li>
                            <label>5发送时间<b>*</b></label>
                            <cite class="left">
                                <input name="immeSend" v-model="immeSend" type="radio" value="1" />立即发送  （订购业务每日会产生最低消费，如果不使用，可以退订。每月可退订1次）
                            </cite> 
                        </li>
    
                        <li><label>&nbsp;</label><input class="sure" type="button" @click="next()" value=" 下一步 ">&nbsp;

                        </li>
                    </ul>

                    <ul class="forminfo" v-show="isShowSmsConfirm">    
                        <li>
                            <label>原始链接</label><input type="text" class="dfinput maringht10" readonly="readonly" v-model="srcUrl" />
                        </li>
                        <li><label>地址有效期</label><div class="toolbars lh33"><strong class="ea2020">{{urlDate}}</strong>天</div></li>
                        <li>
                        <li><label>手机号</label><textarea name="" v-model="mobile" readonly="readonly" cols="" rows="" class="textinput"></textarea>
                        </li>    
                        <li>
                        <label>内容</label>
                            <textarea name="" cols="" v-model="content" rows="" readonly="readonly" class="textinput"></textarea><i class="lh33">（包含了签名）</i> </li>
                        
                        <li><label>签名</label><div class="toolbars lh33">{{sign}}</div></li>
                        
                        <li><label>内容含</label><div class="toolbars lh33"> <strong class="ea2020">{{tjs}}</strong>字  （含签名）</div></li>
                        <li><label>计费条数</label><div class="toolbars lh33"><strong class="ea2020">{{feeLength}}</strong>条  （含长短信  号码未去重，未去错）</div></li>
                        
                        <li><label>发送方式</label>
                            <div class="toolbars lh33"> 立即发送</div>
                        </li>
                        
                        <li><label>通道编号</label>
                            <div class="toolbars lh33"><strong class="ea2020">{{channelcode}}</strong> </div>
                        </li>

                        <li><label>扣费前金额</label>
                            <div class="toolbars lh33"> <strong class="ea2020">{{yemoney}}</strong>元 </div>
                        </li>
                        
                        <li><label>所需费用</label>
                            <div class="toolbars lh33"> 
                                本次费用<strong class="ea2020">{{money}}</strong>元 
                                <strong class="ea2020" v-if="uncheckmoney > 0">,未审核列表里还需扣费{{uncheckmoney}}元</strong>
                            </div>
                        </li>
                        
                        <li><label>扣费后余额</label>
                            <div class="toolbars lh33"><strong class="ea2020"> {{symoney}}</strong>元 </div>
                        </li>
                        
                        <li><label>&nbsp;</label><input class="btn"  type="button" :disabled="smsSendDis" @click="smsSend()" value="确定发送">&nbsp;
                            <input class="cancel" type="button" @click="confirmcancel()" value=" 修 改 ">
                        </li>
                    </ul>
    
                    <div class="jian">&nbsp;</div>
                    <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                    <b>注意</b>
                    </div>
    
                    <ul class="infolist">
                    <li><span class="ea2020">请注意号码数量、字数、通道价格！ 扣费字符是指：中文、英文、符号、空格、回车，每一个字符是代表一个字 </span></li>
                        <li><span>短信问题排查方法</span></li> 
                        <li><span>1、接收号码正确否</span></li>
                        <li><span>2、是否欠费停机，当时不在服务区，或基站信号屏蔽有问题，可试拨打</span></li>
                        <li><span>3、安装过短信过滤软件否，如360之类</span></li>
                        <li><span>4、有否投诉过，被列入运营商白名单、黑名单、红名单</span></li>
                        <li><span>5、是否使用的通道有延时，节假日可能拥堵</span></li>
                        <li><span>6、内容有否包含关键敏感字，政治、诈骗、中奖、抽奖等过于广告夸张字眼，被当地接收运营商屏蔽以上自查皆无问题，可再联络二办客服 </span></li>
                        <li><span>淘宝网店数据导入 注意：请进入快递到/网店管理－数据导入－导入CSV文件</span></li>
                        <li>
                            <span class="ea2020">特别提醒、使用须知说明: </span><a class="ibtn" v-show="!isShowTx" @click="showTx()">点击查看详细</a> <a class="ibtn" v-show="isShowTx" @click="closeTx()">点击关闭详细</a>
                            
                        </li>
                        <div v-show="isShowTx">
                            <li><span>务请在短信后面 <font color='red'><strong>加上签名</strong></font>, 否则易被垃圾短信系统过滤, 标准格式：【XX】 (XX用2字以上您的中文公司名、店铺名、品牌名替换) 第二办公室对广告信息有权拒发或转换通道发送</span></li> 
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、个别低价通道群发时为提高发送成功率，避免屏蔽过滤，会自动替换字词，群发前务请先测试调整; </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、为防止恶意短信，需通过手机验证您的身份，该验证不会从手机恶意扣费。</span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、因节日、促销高峰忙，易堵延时，请及早安排！</span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>个性短信：</strong>分/条；</span></li>
                            <li><span><strong>通道描述\计费:</strong></span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、★ 多代表推荐程度高，供您参，根据测试及使用情况动态调整 </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、以上短信均按提交的号码个数，一般以70字为一条计费；个别低于70字计条或计费，以通道描述为准；小灵通因受字数限制，以58字为一条计费；</span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、<strong>长短信：</strong>指对方接收到的短信，在通道及手机的双重支持下，超过70字的多条内容以一屏显示，方便阅读，但计费仍按多条计</span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、请您仔细核对接受者号码,一旦提交不可取消！ </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、发送者发送短信视为接受本站的内容检查，黑名单过滤、第三方赞助信息插播服务。当短信内容出现关键敏感词时，系统会自动向接收用户进行风险提示，该提示计入发送方费用。 </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6、任何通道均不得发送不健康或违规的短信。本系统默认您发送的短信均已经过接收者同意，如有投诉，请发送人自行承担相关责任。并承担因此给本系统带来的经济或名誉损失，请注意保管好你在本站的账号和密码。发恶意、欺诈、辱骂短信立封账号  </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7、因短信发送过程受网络，运营商网关，基站，接收者号码等多种因素影响，有可能会收不到，超出本站可控范围。因此本网站不受理对方个别号码收不到短信的投诉。为提高发送成功率，请经常更新检查您的号码库。</span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8、群发前，为免当地运营商屏蔽，可检查用词和试发，主要是试发移动号，建议一次发3条以上。节日、促销高峰忙，易堵延时，请及早安排！ </span></li>
                            <li><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9、群发前务请先测试调整内容，并选择合适的时间，勿打扰客户；如被投诉，或恶意发送限制内容即自动过滤，（费用不退还）<font color='red'><strong>余额或内容保证金冻结作为赔偿</strong></font>，并举报到公安，追究其他刑责或赔偿。</span></li>
                            <li><span style="width:100%"><strong>不得有以下内容或行为:</strong></span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. 宣传与运营商有竞争关系的业务，如：给移动号码宣传联通业务，给联通手机宣传移动业务等；</span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. 色情类信息；公关小姐类； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. 刻章、办证、开发票、车牌、证件、职称、企业法人、身份证等；</span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. 非法买卖枪枝、车辆及违禁药品等； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. SP声讯类短信；移动PUSH； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6. 个人贷款；汇款、打款;提交带有中奖字符的信息；</span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7. 体彩、福彩、赛马、赌博、赌码、麻将机、扑克牌等； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. 医院类（宣传妇科、人流、痔疮、男性病等易投诉内容）禁止提交； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9. 辱骂、攻击及骚扰性的内容；</span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.涉及国家法律、法规、政策的；反对宪法所确定的基本原则的； </span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</span></li>
                            <li><span style="width:100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以上对短信、彩信、传真、语音短信等业务均同等约束有效</span></li>
                        </div>
                        <li><span class="ea2020">限制内容及发送时间说明: </span><a class="ibtn" v-show="!isShowXz" @click="showXz()">点击查看详细</a><a class="ibtn" v-show="isShowXz" @click="closeXz()">点击关闭详细</a></li>
                        <div v-show="isShowXz">
                            <li><span>群发前务请先测试调整内容，并选择合适的时间，勿打扰客户；如被投诉，或恶意发送限制内容即自动过滤，（费用不退还）余额或保证金冻结作为赔偿，并举报到公安，追究其他刑责或赔偿。</span></li>
                            <li><span>不得有以下内容或行为:</span></li>
                            <li><span>1. 宣传与运营商有竞争关系的业务，如：给移动号码宣传联通业务，给联通手机宣传移动业务等； 2. 色情类信息；公关小姐类； </span></li>
                            <li><span>3. 刻章、办证、开发票、车牌、证件、职称、企业法人、身份证等；</span></li>
                            <li><span>4. 非法买卖枪枝、车辆及违禁药品等； </span></li>
                            <li><span>5. SP声讯类短信；移动PUSH； </span></li>
                            <li><span>6. 个人贷款；汇款、打款;提交带有中奖字符的信息；</span></li>
                            <li><span>7. 体彩、福彩、赛马、赌博、赌码、麻将机、扑克牌等； </span></li>
                            <li><span>8. 医院类（宣传妇科、人流、痔疮、男性病等易投诉内容）禁止提交； </span></li>
                            <li><span>9. 辱骂、攻击及骚扰性的内容；</span></li>
                            <li><span>10.涉及国家法律、法规、政策的；反对宪法所确定的基本原则的； </span></li>
                            <li><span>11. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。</span></li>
                            <li><span>以上对短信、彩信、传真、语音短信等业务均同等约束有效</span></li>
                        </div>
                    </ul>
                </div> 
	        </div> 
        </div>

        <!--tip1 通讯录-->
        <div class="tip tip1">        
    	    <div class="tiptop"><span>第二办公室-通讯录</span><a></a></div>        
            <div class="tipinfo cen ovhi">      
                <div class="cen ovhi">
                    <label class="left lh33">选择组 &nbsp; </label>
                    <div class="cityleft">
	                    <el-select v-model="txlgroupid" @change="pageChangeTxl()" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option
                                v-for="item in txlGroupList"
                                :key="item.groupid"
                                :label="item.groupname"
                                :value="item.groupid">
                            </el-option>
                        </el-select>
                    </div>
                </div>        
                <table class="tablelist">
    	            <thead>
    	                <tr>
                            <th>
                                <input name="allCheck" id="allCheck" @click="changAllCheck()" type="checkbox" value=""/>
                            </th>
                            <th>姓名</th>
                            <th>号码</th>
                        </tr>
                    </thead>
                    <tbody>    
                        <tr>
                            <td colspan="3" v-show="isSearch">查询中....</td>
                        </tr>    
                        <tr v-for="item in txlContList">
                            <td><input name="txlmphone1" type="checkbox" :value="item.name + '{'+item.mphone1.trim()+'}'" /></td>
                            <td>{{item.name}}</td>
                            <td>{{item.mphone1}}</td>
                        </tr>
                    </tbody>
                </table>        
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure" @click="checkok()"  value="确定" />&nbsp;
                    <input name="" type="button"  class="cancel" @click="close()"  value="取消" />
                </div>    
            </div>    
        </div>
        <!--tip1 end-->

        <!--tip2 群发录-->
        <div class="tip tip2">        
    	    <div class="tiptop"><span>导入群发录</span><a></a></div>        
            <div class="tipinfo cen ovhi">         
                <table class="tablelist">
    	            <thead>
    	                <tr>
                            <th>
                                
                            </th>
                            <th>文件名</th>
                            <th>号码个数</th>
                        </tr>
                    </thead>
                    <tbody>     
                        <tr v-for="(item,index) in smsContTxtList">
                            <td><input type="radio" v-model="sctfile" name="radsct" :value="index" /></td>
                            <td>{{item.filename}}</td>
                            <td>{{item.countnum}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="pagin">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-size="50"
                        layout="total, prev, pager, next"
                        :total="totalCount">
                    </el-pagination>
                </div>
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure" @click="checkoksct()"  value="确定" />&nbsp;
                    <input name="" type="button"  class="cancel" @click="closesct()"  value="取消" />
                </div>        
            </div>        
        </div>

        <!--tip3 短信库-->
        <div class="tip tip3" style="width:600px;">        
    	    <div class="tiptop"><span>第二办公室 -从常用短信库中添加短信内容</span><a></a></div>        
            <div class="tipinfo cen ovhi">      
                <div class="cen ovhi">
                    <label class="left lh33">选择短信组 &nbsp; </label>
                    <div class="cityleft">
	                    <el-select v-model="smsclassfiyid" @change="changeSmsClassFiy()" placeholder="请选择">
                            <el-option
                                v-for="item in smsClassFiyList"
                                :key="item.id"
                                :label="item.typename"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>        
                <table class="tablelist" style="width:500px;">
    	            <thead>
    	                <tr>
                            <th>
                                
                            </th>
                            <th>短信内容</th>
                        </tr>
                    </thead>
                    <tbody>    
                        <tr v-for="item in smsContentList">
                            <td><input name="scontent" type="radio" v-model="scontent" :value="item.content" /></td>
                            <td>{{item.content}}</td>
                        </tr>
                    </tbody>
                </table>        
                <div class="cen pat20 ovhi">
                    <input name="" type="button"  class="sure" @click="checkSmsContent()"  value="确定" />&nbsp;
                    <input name="" type="button"  class="cancel" @click="closetip3()"  value="取消" />
                </div>    
            </div>    
        </div>

    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import { delCookie } from '@/assets/js/cookie.js'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            srcUrl:'',
            urlDate:5,
            scontent:'',
            smschannelList:[],
            channelcode:'',
            isShowFee:'0',
            signList:[],
            sign:'',
            mobile:this.$route.query.mobile == null ? "" : this.$route.query.mobile,
            content:this.$route.query.content == null ? "" : this.$route.query.content,
            txtpath:'',
            format:'phone',
            smsCount:'',
            immeSend:'1',
            isShowSmsConfirm:false,
            isShowSmsSend:true,
            stitls:'短地址群发',
            tjs:0,
            mcont:'',
            mtype:'',
            packageId:'',
            mobileNum:0,
            feeLength:0,
            money:0,   //本次所需费用
            uncheckmoney:0, //未审核列表里的短信费用
            symoney:0,  //剩余金额
            yemoney:0,   //扣费前金额
            txlGroupList:[],
            txlgroupid:'',
            txlContList:[],
            txmobile:'',
            isSearch:true,
            smsTxtUploadUrl:this.GLOBAL.serverSrc + '/sms/uploadsmstxt.json',
            uploadHeaders:{},
            srcfilename:'',
            smsContTxtList:[],
            pageIndex:0,
            totalCount:0,
            sctfile:'',
            smsClassFiyList:[],
            smsclassfiyid:'',
            isSearch2:true,
            smsContentList:[],
            yanzheng:'0',
            isBindMobile:false,
            smsSendDis: false,
            isShowTx:false,
            isShowXz:false,
        }
    },
    mounted(){
        if(this.$route.query.mobile == undefined)
        {
            this.outlogin();
        }
        else
        {
            this.mobile = this.$route.query.mobile;
            this.getSmsSendInfo();
            this.uploadHeaders.token = this.GLOBAL.token;
        }
    },
    methods:{
        outlogin() {
            delCookie('2officesessionid')
            alert("请求地址有误,请重新登录！");
            this.$router.push('/');
        },
        getSmsSendInfo(){
            let that = this;
            let data = {'mobile':this.mobile,'content':this.content};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/initsmssendpage.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.yanzheng = res.data.yanzheng;
                    if('1' == that.yanzheng){
                        that.isBindMobile = true;
                    }
                    else{
                        that.isBindMobile = false;
                    }
                    that.smschannelList = res.data.smsChannelList;
                    that.isShowFee = res.data.isShowFee == null ? "0" : res.data.isShowFee;
                    that.signList = res.data.signList;
                    if(null != that.signList && that.signList.length > 0){
                        that.sign = that.signList[0].sign
                    }
                    if(null != that.smschannelList && that.smschannelList.length > 0){
                        that.channelcode = that.smschannelList[0].channelCode
                    }
                    that.smsCount = res.data.smsCount;
                    that.packageId = res.data.packageId;
                    that.tjcontentlen();
                }
                else if("0030001" == res.data.code){
                    if(confirm("您还未订购短信宝业务或者总机业务，现在去订购吗？")){
                        location.href = "/userpackage";
                    }
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        next(){
            // alert(this.mobile);
            if(this.srcUrl.trim() == ''){
                alert("请先填写原始链接！");
                return;
            }
            if(this.srcUrl.trim.length > 100){
                alert("原始链接长度不能超过100");
                return;
            }
            if(!this.srcUrl.trim().startsWith("http")){
                alert("原始链接必须以http开头");
                return;
            }
            if(this.channelcode.trim() == ''){
                alert("请先选择通道编号！");
                return;
            }
            if(this.mobile.trim() == ''){
                alert("手机号码不能为空！");
                return;
            }
            if(this.mobile.trim().length < 11){
                alert("手机号码不正确！");
                return;
            }
            var m = this.mobile.trim();
            var regS = new RegExp("\\$","g");
            //m = m.replace(regS,",");
            m = m.replace(/，/g,",");
            m = m.replace(/\n/g,",");
            m = m.replace(/\t/g,",");
            var regS1 = new RegExp("　","g");
            m = m.replace(regS1,",");
            m = m.replace(",,",",");
            m = m.replace(" ,",",");
            var regs2 = new RegExp(" ,","g");
            m = m.replace(regs2,",");
            if( ',' == m.substr(m.length-1,1) )
            {
                m = m.substr(0, m.length-1)
            }
            if(m.split(',').length > 500)
            {
                alert('超出500个手机号，请用txt形式导入号码！');
                return;
            }
            this.mobile = m;
            
            if(this.mobile.indexOf("您的号码文件")==-1){

                var jgpattern =/\d{11}/; 
                if(!jgpattern.test(this.mobile)){ 
                    alert("号码有误，请核对！");
                    return false; 
                } 
            }
            if(this.content.trim() == ''){
                alert("短信内容不能为空！");
                return;
            }
            this.content = this.content.replace(/\n/g,",");
            if(this.content.trim().indexOf("【")!=-1 || this.content.trim().indexOf("】")!=-1){
                alert("短信内容不能包含签名【】！");
                return;
            }
            if(this.sign.trim() == ''){
                alert("请选择签名！");
                return;
            }
            if(this.mobile.indexOf("您的号码文件") == -1){
                this.txtpath = "";
                this.format = "phone";
            }
            if(this.tjs > 300){
                alert("短信内容最大长度不能超过300！");
                return;
            }
            if(this.channelcode.trim() == '7883')
            {                
                if( this.content.trim().indexOf("回T退订")==-1)
                {
                    alert("短信内容里必须包含‘回T退订’");
                    return false;
                }
            }
            
            if(this.channelcode.trim() == '699' || this.channelcode.trim() == '723')
            {
                if(this.content.trim().indexOf("拒收请回复R")==-1)
                {
                    alert("短信内容里必须包含‘拒收请回复R’");
                    return false;
                }
            }

            if(this.channelcode.trim() == '7882')
            {                
                if(this.content.trim().indexOf("拒收请回复R")==-1)
                {
                    alert("短信内容里必须包含‘拒收请回复R’");
                    return false;
                }
                if( this.sign.trim() =='【腾讯渠道】' && this.content.trim().indexOf('【腾讯渠道】')!=-1)
                {
                    alert("已经选择了签名【腾讯渠道】，短信内容里不需再加签【腾讯渠道】");
                    return false;
                }

                if(this.sign.trim() !='【腾讯渠道】')
                {
                    alert("7882通道必须选择【腾讯渠道】为签名,短信内容中除签名外不能出现“【】”符号");
                    return false;
                }
            }
            
            if(this.channelcode.trim() == '788')
            {
                if(this.sign != '【阿里巴巴】' && this.sign != '【阿里渠道】'){
                    alert("788通道必须选择【阿里巴巴】或者【阿里渠道】为签名,短信内容中除签名外不能出现“【】”符号");
                    return false;
                }
                if(this.content.trim().indexOf("拒收请回复R")==-1)
                {
                    alert("短信内容里必须包含‘拒收请回复R’");
                    return false;
                }           
            }

            if(this.channelcode.trim() == '728')
            {
                if(window.confirm('728通道只发通知类短信，营销类短信拒发。您确定使用吗？')){
                    
                }else{                
                    return false;
                }
            }

            if(this.channelcode.trim() == '199')
            {
                if (this.content.trim().indexOf("亲")==-1 ) {
                    alert("短信内容开头必须是‘亲’");
                    return false;
                }
                
                if(this.content.indexOf("拒收请回复R")==-1)
                {
                    alert("短信内容里必须包含‘拒收请回复R’");
                    return false;
                }                
            }
            if(this.sign == '【阿里巴巴】' || this.sign === '【阿里渠道】' || this.sign === '【腾讯渠道】'){
                if(this.content.indexOf("拒收请回复R")==-1)
                {
                    alert("短信内容里必须包含‘拒收请回复R’");
                    return false;
                }  
            }
            
            let that = this;
            let data = {'srcUrl':this.srcUrl,'urlDate':this.urlDate,'mobile':this.mobile,'content':this.content,'sign':this.sign,'channelCode':this.channelcode,'format':this.format,'txtpath':this.txtpath,'packageId':this.packageId,'mobileNum':this.mobileNum,'orgId':'','loginId':'','immeSend':this.immeSend,'mtype':this.mtype,'mcont':this.mcont};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/confirmshortsmssend.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.srcUrl = res.data.srcUrl == undefined ? "" : res.data.srcUrl;
                    that.urlDate = res.data.urlDate == undefined ? 5 : res.data.urlDate;
                    that.feeLength = res.data.feeLength;
                    that.money = res.data.money;
                    that.tjs = res.data.contentLength;
                    that.mobile = res.data.mobile;
                    that.content = res.data.content;
                    that.yemoney = res.data.yemoney;
                    that.symoney = res.data.symoney;
                    that.uncheckmoney = res.data.uncheckmoney;
                    that.stitls = "确认短信提交信息";
                    that.isShowSmsConfirm = true;
                    that.isShowSmsSend = false;                    
                    $('body,html').animate({scrollTop:0},10);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
            
        },
        confirmcancel(){
            this.stitls = "短地址群发";
            this.isShowSmsConfirm = false;
            this.isShowSmsSend = true;
            $('body,html').animate({scrollTop:0},10);
        },
        tjcontentlen(){
            this.tjs = this.content.length + this.sign.length;
        },
        changeSign(sign){
            this.tjs = this.content.length + sign.length;
        },
        smsSend(){
            if(this.channelcode.trim() == ''){
                alert("请先选择通道编号！");
                return;
            }
            if(this.mobile.trim() == ''){
                alert("手机号码不能为空！");
                return;
            }
            if(this.content.trim() == ''){
                alert("短信内容不能为空！");
                return;
            }
            if(this.sign.trim() == ''){
                alert("请选择签名！");
                return;
            }
            this.smsSendDis = true;
            let that = this;
            var dateNow = new Date();
            var ff = dateNow.getTime();
            
            let data = {'srcUrl':this.srcUrl,'urlDate':this.urlDate, 'mobile':this.mobile,'content':this.content+this.sign,'channelCode':this.channelcode,'format':this.format,'txtpath':this.txtpath,'packageId':this.packageId,'smsId':this.getSmsId(),'orgId':'','loginId':'','feeLength':this.feeLength,'immeSend':this.immeSend,'mtype':this.mtype,'mcont':this.mcont,'srcfilename':this.srcfilename};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsshortsend.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("短信已提交成功，客服审核后自动发送，切勿重复提交！");
                    that.$router.push('/smscheck')
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        getSmsId(){
            var dcDate = new Date();
            var year = dcDate.getFullYear();
            var month = dcDate.getMonth()+1;
            if(month < 10)
                month = "0" + month;
            var date = dcDate.getDate();
            if(date < 10)
                date = "0" + date;
            var hours = dcDate.getHours();
            if(hours < 10)
                hours = "0" + hours;
            var minutes = dcDate.getMinutes();
            if(minutes < 10)
                minutes = "0" + minutes;                
            var seconds = dcDate.getSeconds();
            if(seconds < 10)
                seconds = "0" + seconds;
            var milliseconds = dcDate.getMilliseconds();
            if(milliseconds<10)
                milliseconds = "00" + milliseconds;
            else if(milliseconds >=10 && milliseconds <=99)
                milliseconds = "0" + milliseconds;

            var smsid = year + "" + month + "" + date + "" + hours + "" + minutes + "" + seconds + "" + milliseconds;
            return smsid;
        },
        gotoSign(){
            location.href = "/smssign";
        },
        addTxl(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
            this.pageChangeTxl();
        },
        pageChangeTxl(){
            var that = this
            let data = {'groupid':this.txlgroupid}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlcontmphone.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlContList = res.data.txlContList;
                    that.txlGroupList = res.data.txlGroupList;
                    that.isSearch = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
            // checkok();
            
        },
        changAllCheck(){
            var checkers = document.getElementsByName('txlmphone1');
            if (document.getElementById("allCheck").checked == true)
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = true;
                }
            }
            else
            {
                for ( var i = 0; i < checkers.length; i++)
                {
                    checkers[i].checked = false;
                }
            }
        },
        checkok(){
            var info = '';
            var checkers = document.getElementsByName('txlmphone1');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    if(info =='')
                        info = checkers[i].value;
                    else
                        info = info + ',' + checkers[i].value;
                }
            }
            if(this.mobile == '')
                this.mobile = info;
            else
                this.mobile = this.mobile + "," + info;
            this.closeTxl();
        },
        closeTxl(){
            $(".tip1").fadeOut(200);
        },
        uploadSuccess(response){
            if (response.code === '0000000') {
                this.txtpath = response.txtPath;
                this.mobileNum = response.mobileNum;
                this.format = "txt";
                this.srcfilename = response.srcFileName;
                this.mobile = "您的号码文件" + response.srcFileName + "上传成功，请填写内容发送."
            }
            else if("0000006" == response.code){
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                // console.log(JSON.stringify(response.data))
            }
        },
        handleChange(file, fileList) {
            
        },
        gotoGeXing(){
            location.href = "/smsgexing"
        },
        addSmsContTxt(){
            $(".tip2").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip2").fadeOut(200);
            })
            this.sctfile = '';
            this.pageChangeSCT(1);
        },
        pageChangeSCT(pageIndex){
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsconttxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsContTxtList = res.data.smsContTxtList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        handleCurrentChange(val){
            this.pageChangeSCT(val);
        },
        closesct(){
            $(".tip2").fadeOut(200);
        },
        selectfile(filepath, countnum){
            alert(filepath+',' + countnum);
        },
        checkoksct(){
            var index = -1;
            var checkers = document.getElementsByName('radsct');
            for ( var i = 0; i < checkers.length; i++){
                if(checkers[i].checked){
                    index = checkers[i].value;
                }
            }
            if(index < 0){
                alert("请先选择要导入的群发录！");
                return;
            }
            //alert(this.smsContTxtList[index].filepath + "," + this.smsContTxtList[index].smscount);
            this.format = 'txt';
            this.txtpath = this.smsContTxtList[index].filepath;
            this.mobile = "您的号码文件" + this.smsContTxtList[index].filename + "上传成功，请填写内容发送.";
            this.closesct();
        },
        addFromSmsContent(){
            $(".tip3").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip3").fadeOut(200);
            })
            let that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsclassfiy.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    
                    that.smsClassFiyList = res.data.smsClassFiyList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        changeSmsClassFiy(){
            let that = this;
            let data = {'id':this.smsclassfiyid};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getsmsclassfiycontent.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.isSearch2 = false;
                    that.smsContentList = res.data.smsContentList;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        closetip3(){
            $(".tip3").fadeOut(200);
        },
        checkSmsContent(){
            this.content = this.scontent;
            this.closetip3();
            this.tjcontentlen();
        },
        gotoBindMobile(){
            location.href = "/bindmobile"
        },
        addShortUrl(){
            var obj = document.getElementById('content');
            var str = "canv.cn/##短链##";
            if (document.selection) {
                var sel = document.selection.createRange();
                sel.text = str;
            } else if (typeof obj.selectionStart === 'number' && typeof obj.selectionEnd === 'number') {
                var startPos = obj.selectionStart,
                endPos = obj.selectionEnd,
                cursorPos = startPos,
                tmpStr = obj.value;
                obj.value = tmpStr.substring(0, startPos) + str + tmpStr.substring(endPos, tmpStr.length);
                cursorPos += str.length;
                obj.selectionStart = obj.selectionEnd = cursorPos;
            } else {
                obj.value += str;
            }
            this.content = obj.value;

            this.tjs = this.content.length + this.sign.length;
        },
        showTx(){
            this.isShowTx = true;
        },
        closeTx(){
            this.isShowTx = false;
        },
        showXz(){
            this.isShowXz = true;
        },
        closeXz(){
            this.isShowXz = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsshortsend.vue